var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("sc-notification"),
      _vm._v(" "),
      _vm.screenMode !== _vm.screenModes.SIMPLE
        ? _c("sc-header", { attrs: { "remote-access-info": _vm.remoteAccess } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "main", class: [_vm.screenModeCls, _vm.spacingEnvCls] },
        [
          _vm.screenMode === _vm.screenModes.NORMAL
            ? _c(
                "div",
                {
                  class: {
                    main__menu: !_vm.newMenu,
                    main__menu__new: _vm.newMenu
                  }
                },
                [
                  !_vm.newMenu ? _c("sc-nav") : _vm._e(),
                  _vm._v(" "),
                  _vm.newMenu
                    ? _c("sc-menu", { on: { getmenustate: _vm.setMenuState } })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              class: [
                _vm.menuState
                  ? "main__menu__new--spacing"
                  : "main__menu__new--nospacing",
                _vm.newMenu && _vm.screenMode === _vm.screenModes.NORMAL
                  ? "main__content__new"
                  : "main__content"
              ]
            },
            [
              _vm.getDiffDays <= 120 &&
              _vm.screenMode !== _vm.screenModes.SIMPLE
                ? _c(
                    "article",
                    {
                      staticClass:
                        "message is-warning message-remote-access is-marginless"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "message-body" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.alertMessageNewMenu) +
                              "\n              "
                          ),
                          _c("sc-switch", {
                            attrs: { size: "is-small" },
                            on: { input: _vm.toggleMenu },
                            model: {
                              value: _vm.newMenu,
                              callback: function($$v) {
                                _vm.newMenu = $$v
                              },
                              expression: "newMenu"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("router-view")
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ac2ab72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ac2ab72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/features/private/home/PageHome.vue
// module id = null
// module chunks = 